// extracted by mini-css-extract-plugin
export default {"wrap":"theme-wrap-2IBB3","groupLabel":"theme-groupLabel-2f_fe","list":"theme-list-Xsk3d","item":"theme-item-1qaX6","icon":"theme-icon-2pEWE","badge":"theme-badge-3a2HG"};